/**
 * A value that follows `value` once it has held still for `ms` (SA-1056: its own file; it lived in
 * the airports hooks, which still re-export it).
 */
import { useEffect, useState } from 'react'

export function useDebouncedValue<T>(value: T, ms: number): T {
  const [debounced, setDebounced] = useState(value)
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), ms)
    return () => clearTimeout(t)
  }, [value, ms])
  return debounced
}
